export default __webpack_public_path__ + "static/media/Jowar.fe37dfc3.jpg";